const UrlUtils = {
    _slash: "/",

    trimTrailingSlash(url: string) {
        return url?.endsWith(this._slash) ? url.slice(0, -1) : url
    },

    join(url: string, path: string | undefined) {
        url = this.trimTrailingSlash(url);

        if (!path) {
            return url;
        }

        const separator = path.startsWith(this._slash) ? "" : this._slash;

        return url + separator + path;
    }
}

export default UrlUtils;